import axios from 'axios';
import {store} from "./main.js"

export class getData {
    periods = {
        'Last Month': 'month',
        'Last 3 Months': 'threemonths',
        'Last 6 Months': 'sixmonths',
        'Last year': 'twelvemonths'
    };

    constructor(init) {
        try {
            if (init) {
                store.MyEvent.listen('config_loaded', () => {
                    this.getRealAggrData();
                });
            }
        } catch (e) {
        }
    }

    async getRealAggrData(period) {
        if (typeof period == 'undefined')
            period = 'Last Month';

        var query = this.periods[period];

        let response = await axios.get(store.config.api_location + '/GetWiDEInternalData/' + query + '/subsystem').catch(function () {
        });

        if (typeof response != 'undefined' && response.status == 200) {
            store.subSystemAggr = JSON.parse(response.data.data);
        }

        response = await axios.get(store.config.api_location + '/GetWiDEInternalData/' + query + '/enginetype').catch(function () {
        });

        if (typeof response != 'undefined' && response.status == 200) {
            var tmp = JSON.parse(response.data.data);

            Object.keys(tmp).forEach(type=>{
                tmp[type].vesselNo = [...new Set(tmp[type].engines.map(o=>o.vessel))].length;
            })
            store.engineAggr = tmp;
        }

        response = await axios.get(store.config.api_location + '/GetWiDEInternalData/' + query + '/customers').catch(function () {
        });

        if (typeof response != 'undefined' && response.status == 200) {
            var tmp = JSON.parse(response.data.data),
                result = {};

            for (var i in tmp) {
                if (tmp.hasOwnProperty(i) && tmp[i].is_shipping == 1) {
                    result[i] = tmp[i];
                }
            }

            store.companyAggr = result;
        }


        response = await axios.get(store.config.api_location + '/GetWiDEInternalData/GetVesselTickets/').catch(function () {
        });

        if (typeof response != 'undefined' && response.status == 200) {
            store.vesselTickets = response.data.data.vessels;
        }

        store.type = query;
    }

    async getRules() {
        let response = await axios.get(store.config.api_location + '/faultrules').catch(function () {
        });

        if (typeof response != 'undefined' && response.status == 200) {
            store.rules = Object.assign({}, response.data.data);
        }
    }

    async getMissing() {
        let period;

        switch (store.type) {
            case 'month':
                period = 'month'
                break;
            case 'threemonths':
                period = '3months'
                break;
            case 'sixmonths':
                period = '6months'
                break;
            case 'twelvemonths':
                period = '12months'
                break;
        }

        let faults = [],
            filters = [],
            response = await axios.get(`${store.config.api_location}/faults/missing/${period}`)
            .catch(function () {
            });

        if (typeof response != 'undefined' && response.status == 200) {
            faults = response.data.data.faults;
            filters = response.data.data.filters;
        }

        return [faults, filters];
    }

    async getFleetInfo() {
        let companies = [],
            response = await axios.get(store.config.api_location + `/vessel/fleet/`)
            .catch(function () {
            });

        if (typeof response != 'undefined' && response.status == 200) {
            companies = response.data.data.companies;
        }

        return companies;
    }
}